module.exports = __webpack_public_path__ + "img/icon_fp_link3.0df01d42.svg";